import { FC, useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import { Link } from 'react-router-dom'

import { useAuth } from 'react-oidc-context'
import {
  BarsIcon,
  FileTextIcon,
  MentorsIcon,
  RecentIcon,
} from '../../../components/Icons'
import { VideoIcon } from '../icons'

interface IAdminNavigationProps {
  isMobile?: boolean
}

const adminMenuItems = [
  // {
  //   label: "Home",
  //   link: "/",
  //   icon: <HomeIcon />,
  // },
  {
    label: 'Companions',
    link: '/admin/all-mentors',
    icon: <MentorsIcon />,
  },
  {
    label: 'Recent',
    link: '/admin/recent',
    icon: <RecentIcon />,
  },
  {
    label: 'Carousel',
    link: '/admin/carousel',
    icon: <VideoIcon />,
  },
  {
    label: 'Prompts',
    isLimitedAdminAccess: true,
    link: '/admin/prompts',
    icon: <FileTextIcon className="w-4 h-4" />,
  },
]

// TODO: remove this check when we have a proper role
export const allowedAdminEmailForPrompt = [
  'marius@touchcast.com',
  'egor.Sydorenko@touchcast.com',
]

const AdminNavigation: FC<IAdminNavigationProps> = ({ isMobile }) => {
  const { user } = useAuth()
  const location = useLocation()
  const [showMenu, setShowMenu] = useState(!isMobile)

  const handleToggleMenu = () => {
    setShowMenu(!showMenu)
  }

  useEffect(() => {
    if (showMenu) {
      document.body.classList.remove('tc-mv-main-nav-hidden')
      return
    }
    document.body.classList.add('tc-mv-main-nav-hidden')
  }, [showMenu])

  useEffect(() => {
    setShowMenu(!isMobile)
  }, [isMobile])

  return (
    <div>
      <button
        onClick={handleToggleMenu}
        className="flex align-middle border-0 h-10 justify-center rounded-full text-white w-10 absolute font-medium hover:backdrop-blur-[50px] hover:bg-[rgba(128,128,128,0.30)] hover:border-[rgba(255,255,255,0.40)] items-center left-[-68px] tc-mv-main-menu top-0"
        title="Main Menu"
      >
        <BarsIcon />
      </button>

      <div
        className={`fixed top-[72px] w-52 shadow-lg z-50 p-4 tc-mv-main-nav gap-2 flex flex-col ${showMenu ? 'block' : 'hidden'}`}
      >
        {adminMenuItems.map(({ label, link, icon, ...rest }, index) => {
          const shouldShowItem = rest?.isLimitedAdminAccess
            ? allowedAdminEmailForPrompt?.includes(user?.profile.email || '')
            : true

          return shouldShowItem ? (
            <Link
              key={index}
              to={link}
              className={`
          flex rounded-2xl h-12 items-center justify-start px-4 py-3 text-white text-lg 
          ${
            link === location.pathname
              ? 'tc-mv-blur border-0'
              : 'hover:bg-hover-gray'
          }`}
            >
              {icon}
              <span className="font-medium ml-[22px]">{label}</span>
            </Link>
          ) : null
        })}
      </div>
    </div>
  )
}

export { AdminNavigation }
